export default "__VITE_ASSET__CeXw0TJz__"